<template>
    <div style="padding: 2rem 0rem 0rem 2rem;">

        <el-dialog  title="基本信息"  :visible.sync="dialogVisible"  width="75%"  :before-close="handleClose">

            <el-form style="display: flex;flex-wrap: wrap;" v-if="CourseCancellationomponentsTypeDistinguish === '课消审批'">
                <el-form-item label="统计类型:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"> {{ input1 }} </div >
                </el-form-item>

                <el-form-item label="老师姓名:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"  > {{ input2 }} </div >
                </el-form-item>

                <el-form-item label="实际课消次数:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"  > {{ input3 }}  </div >
                </el-form-item>

                <el-form-item label="实际课消金额:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"  > {{ input4 }} </div >
                </el-form-item>

                <el-form-item label="老师课时费:" style="display: flex;width: 50%;">
                    <div  style="width: 100%" > {{ input5 }} </div >
                </el-form-item>
            </el-form>



            <el-form style="display: flex;flex-wrap: wrap;" v-if="CourseCancellationomponentsTypeDistinguish === '取消课消审批'">
                <el-form-item label="课程:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"> {{ cancelFrom.input1 }} </div >
                </el-form-item>

                <el-form-item label="任课老师:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"  > {{ cancelFrom.input2 }} </div >
                </el-form-item>

                <el-form-item label="日期:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"  > {{ cancelFrom.input3 }}  </div >
                </el-form-item>

                <!-- <el-form-item label="排课状态:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"  > {{ cancelFrom.input4 }} </div >
                </el-form-item> -->

                <el-form-item label="开始时间:" style="display: flex;width: 50%;">
                    <div  style="width: 100%" > {{ cancelFrom.input5 }} </div >
                </el-form-item>

                <!-- <el-form-item label="同步状态:" style="display: flex;width: 50%;">
                    <div  style="width: 100%" > {{ cancelFrom.input6 }} </div >
                </el-form-item> -->

                <el-form-item label="结束时间:" style="display: flex;width: 50%;">
                    <div  style="width: 100%" > {{ cancelFrom.input7 }} </div >
                </el-form-item>

                <el-form-item label="班型:" style="display: flex;width: 50%;">
                    <div  style="width: 100%" > {{ cancelFrom.input8 }} </div >
                </el-form-item>

                <el-form-item label="上课人员类型:" style="display: flex;width: 50%;">
                    <div  style="width: 100%" > {{ cancelFrom.input9 }} </div >
                </el-form-item>
            </el-form>



            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="200" v-if="CourseCancellationomponentsTypeDistinguish === '课消审批'">
                <el-table-column prop="courseDate" label="日期" show-overflow-tooltip></el-table-column>
                <el-table-column prop="courseStartTime" label="开始时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="courseEndTime" label="结束时间" show-overflow-tooltip></el-table-column>
                <el-table-column prop="courseName" label="课程" show-overflow-tooltip></el-table-column>
                <el-table-column prop="studentName" label="学员" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="isSales" label="课消状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.isSales === 0">未课消</div>
                      <div v-if="scope.row.isSales === 1">已课消</div>
                  </template>
                </el-table-column> -->
                <el-table-column prop="salesNum" label="课消次数" show-overflow-tooltip></el-table-column>
                <el-table-column prop="salesMoney" label="课消金额" show-overflow-tooltip></el-table-column>
                <el-table-column prop="classFee" label="老师课时费" width="150" show-overflow-tooltip></el-table-column>
                <el-table-column prop="productClassType" label="班型" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.productClassType === 1">1v1</div>
                      <div v-if="scope.row.productClassType === 2">1v2</div>
                      <div v-if="scope.row.productClassType === 3">1v3</div>
                  </template>
                </el-table-column>
                <el-table-column prop="classPersonType" label="上课人员" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.classPersonType === 1">孩子</div>
                      <div v-if="scope.row.classPersonType === 2">孩子和父亲</div>
                      <div v-if="scope.row.classPersonType === 3">孩子和母亲</div>
                      <div v-if="scope.row.classPersonType === 4">父亲</div>
                      <div v-if="scope.row.classPersonType === 5">母亲</div>
                      <div v-if="scope.row.classPersonType === 6">父亲和母亲</div>
                      <div v-if="scope.row.classPersonType === 7">孩子、父亲、母亲</div>
                  </template>
                </el-table-column>
                <el-table-column prop="feeProduct" label="扣费产品" show-overflow-tooltip></el-table-column>
                <el-table-column prop="giveHour" label="赠送课消次数" show-overflow-tooltip width="150"></el-table-column>
            </el-table>


            <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="200" v-if="CourseCancellationomponentsTypeDistinguish === '取消课消审批'">
                <el-table-column prop="studentName" label="姓名" show-overflow-tooltip></el-table-column>
                <el-table-column prop="sex" label="性别" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.sex === 1">男</div>
                      <div v-if="scope.row.sex === 2">女</div>
                  </template>
                </el-table-column>
                <el-table-column prop="gradeName" label="年级" show-overflow-tooltip></el-table-column>
                <el-table-column prop="educationType" label="上课方式" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.educationType === 1">网课</div>
                      <div v-if="scope.row.educationType === 2">上门</div>
                      <div v-if="scope.row.educationType === 3">门店</div>
                  </template>
                </el-table-column>
                <el-table-column prop="telephone" label="联系电话" show-overflow-tooltip></el-table-column>
                <!-- <el-table-column prop="classEnding" label="结课状态" show-overflow-tooltip>
                  <template slot-scope="scope">
                      <div v-if="scope.row.classEnding === 1">结课</div>
                      <div v-if="scope.row.classEnding === 2">未结课</div>
                  </template>
                </el-table-column> -->
                <el-table-column prop="address" label="家庭住址" show-overflow-tooltip></el-table-column>
            </el-table>



            <el-divider>提交人信息</el-divider>


            <el-form style="display: flex;flex-wrap: wrap;">
                <el-form-item label="提交人:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"> {{ input6}} </div >
                </el-form-item>

                <el-form-item label="备注:" style="display: flex;width: 50%;">
                    <div  style="width: 100%"  > {{ input7 }} </div >
                </el-form-item>

                <el-form-item label="状态:" style="display: flex;width: 50%;">
                    <div  style="width: 100%" :style="{ color: input8 === '驳回' ? 'red' : 'green' }"> {{ input8 }}  </div >
                </el-form-item>

                <el-form-item label="审批人:" style="display: flex;width: 100%;">
                    <div  style="width: 100%"> {{ realityAuditName }}  </div >
                </el-form-item>

                <el-form-item label="审批时间:" style="display: flex;width: 100%;">
                    <div  style="width: 100%"> {{ auditDate }}  </div >
                </el-form-item>
            </el-form>







            <span slot="footer" class="dialog-footer">
                <el-button  v-if="CourseCancellationComponentsType !== '详情'"  size="small" class="btns" style="height: 30px;" type="danger" @click="handleReject">驳 回</el-button>
                <el-button  v-if="CourseCancellationComponentsType !== '详情'"  size="small" class="btns" style="height: 30px;" type="primary" @click="handleSubmit">确 定</el-button>
                <el-button  size="small" class="btns" style="height: 30px;" @click="handleClose">取 消</el-button>
            </span>

        </el-dialog>



        <CourseCancellRejectDialog v-if="rejectDialogShow" :dataListNode="dataList" :dataRow="dataRow" @handleEventBus="handleEventBus" @handleEventBusSbut="handleEventBusSbut" :CourseCancellationomponentsTypeDistinguish="CourseCancellationomponentsTypeDistinguish"> </CourseCancellRejectDialog>


    </div>
</template>


    <script>
    import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
    import axios from "axios";
    import apiBaseUrl from "../../config/api";

    import CourseCancellRejectDialog from './CourseCancellRejectDialog'

    export default {
        props:{
            CourseCancellationComponentsType:{
                default:'',
                type:String
            },
            CourseCancellationComponentsID:{
                default:'',
                type: Number
            },
            CourseCancellationomponentsTypeDistinguish:{
                default:'',
                type:String
            },
        },
        components:{
           CourseCancellRejectDialog
        },
        data() {
           return{
              dialogVisible: true,

              input1:'',
              input2:'',
              input3:'',
              input4:'',
              input5:'',

              realityAuditName:'',
              auditDate:'',
            

              dataList:[],

              input6:'',
              input7:'',
              input8:'',


              rejectDialogShow:false,

              cancelFrom:{
                input1:'',
                input2:'',
                input3:'',
                input4:'',
                input5:'',
                input6:'',
                input7:'',
                input8:'',
                input9:'',
              },


              dataRow:{},

           }
        },

        mounted(){

        },


        methods:{

            handleInit(scheduleId){

                  if(this.CourseCancellationomponentsTypeDistinguish === '课消审批'){
                      axios.get(`${apiBaseUrl}/salesAudit/details/${scheduleId}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
                        const data = res.data.data
                        this.dataRow = data
                        if(data){

                            // this.dataList = [{
                            //     educationType: data.educationType,
                            //     classEnding: data.classEnding,
                            //     sex: data.sex,
                            //     studentName: data.studentName,
                            //     gradeName: data.gradeName,
                            //     telephone: data.telephone,
                            //     address: data.address,
                            // }]


                            this.dataList = data.salesList

                            this.input1 = data.statisticsType === 1 ? '老师课消' : ''
                            this.input2 = data.teacherName ? data.teacherName : ''
                            this.input3 = data.salesNum ? data.salesNum : ''
                            this.input4 = data.salesMoney ? data.salesMoney : ''
                            this.input5 = data.classFee ? data.classFee : ''

                            this.input6 = data.commitName ? data.commitName : ''
                            this.input7 = data.commitRemark ? data.commitRemark : ''
                            this.input8 = data.auditStatus === 1 ? '驳回' : data.auditStatus === 2 ? '已完成' : data.auditStatus === 0 ? '待审批' :''

                            this.realityAuditName = data.realityAuditName
                            this.auditDate = data.auditDate


                        }else{
                            this.dataList = []
                        }
                        console.log(data, 'data')
                      })
                }


                if(this.CourseCancellationomponentsTypeDistinguish === '取消课消审批'){
                    axios.get(`${apiBaseUrl}/cancelEnding/details/${scheduleId}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
                      const data = res.data.data

                      this.dataRow = data

                      if(data){

                          this.cancelFrom.input1 = data.courseName ? data.courseName : ''
                          this.cancelFrom.input2 = data.teacherName ? data.teacherName : ''
                          this.cancelFrom.input3 = data.courseDate ? data.courseDate : ''
                          this.cancelFrom.input4 = data.courseStatus === 1 ? '实际课' : data.courseStatus === 2 ? '预排课' : ''
                          this.cancelFrom.input5 = data.courseStartTime ? data.courseStartTime : ''
                          this.cancelFrom.input6 = data.synchronizationStatus === 0 ? '未同步' : data.synchronizationStatus === 1 ? '已同步' : ''
                          this.cancelFrom.input7 = data.courseEndTime ? data.courseEndTime : ''
                          this.cancelFrom.input8 = data.productClassType === 1 ? '1v1' : data.productClassType === 2 ? '1v2' : data.productClassType === 3 ? '1v3' : ''
                          this.cancelFrom.input9 = data.classPersonType === 1 ? '孩子' : data.classPersonType === 2 ? '孩子和父亲' : data.classPersonType === 3 ? '孩子和母亲' : data.classPersonType === 4 ? '父亲' : data.classPersonType === 5 ? '母亲' : data.classPersonType === 6 ? '父亲和母亲' : data.classPersonType === 7 ? '孩子、父亲、母亲' : ''

                          this.input6 = data.commitName ? data.commitName : ''
                          this.input7 = data.commitRemark ? data.commitRemark : ''
                          this.input8 = data.auditStatus === 1 ? '驳回' : data.auditStatus === 2 ? '已完成' : data.auditStatus === 0 ? '待审批' :''

                          this.realityAuditName = data.realityAuditName
                          this.auditDate = data.auditDate

                          this.dataList = [{
                              educationType: data.educationType,
                              classEnding: data.classEnding,
                              sex: data.sex,
                              studentName: data.studentName,
                              gradeName: data.gradeName,
                              telephone: data.telephone,
                              address: data.address,
                          }]

                        }else{
                          this.dataList = []
                      }
                      console.log(data, 'data')
                    })
                }


            },

            handleClose(){
                this.$emit('handleEmit',false)
            },

            handleReject(){
                this.dialogVisible = false
                this.rejectDialogShow = true
            },

            handleSubmit(){
              if(this.CourseCancellationomponentsTypeDistinguish === '课消审批'){
                axios.post(`${apiBaseUrl}/salesAudit/audit`, { auditStatus: 2, id: this.dataRow.id, rejectCause: this.dataRow.rejectCause, remark: this.dataRow.rejectRemark },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
                  if(res.data.code === 200){
                    this.$message({  message: res.data.message,   type: 'success' })
                    this.$emit('handleEmit',false)
                  }else{
                    this.$message({  message: res.data.message,   type: 'error' })
                  }
                })
              }
              if(this.CourseCancellationomponentsTypeDistinguish === '取消课消审批'){
                axios.post(`${apiBaseUrl}/cancelEnding/audit`, { auditStatus: 2, id: this.dataRow.id, rejectCause: this.dataRow.rejectCause, remark: this.dataRow.rejectRemark},{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
                  if(res.data.code === 200){
                    this.$message({  message: res.data.message,   type: 'success' })
                    this.$emit('handleEmit',false)
                  }else{
                    this.$message({  message: res.data.message,   type: 'error' })
                  }
                })
              }
            },


            handleEventBus(event){
                this.rejectDialogShow = event
                this.dialogVisible = true
            },
            handleEventBusSbut(event){
                this.rejectDialogShow = event
                this.$emit('handleEmit',false)
            },

        }

    }
    </script>


    <style scoped lang="less">

        .no-click {
            pointer-events: none;
        }




    </style>



// WEBPACK FOOTER //
// src/ApprovalManagement/CourseCancellationomponents.vue